var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/native-promise-constructor.js
// module id = 426
// module chunks = 3